import type { Choice } from "@memorang/types";
import { useAppTheme } from "../../../../../useAppTheme";
import type { ScoreTone } from "./review-helpers";

export type ReorderParagraphProps = {
	instruction: string;
	paragraphs: Choice[];
	values?: string[];
	onChangeValues?: (values: string[]) => void;
	disabled?: boolean;
	isAnswered?: boolean;
	inReviewMode?: boolean;
	correctOrder?: string[];
	earnedPoints?: number;
	maxPoints?: number;
};

export type ReviewState = "neutral" | "correct" | "incorrect";

export const useCardColors = (reviewState: ReviewState, selected?: boolean) => {
	const theme = useAppTheme();
	if (reviewState === "correct") {
		return {
			borderColor: theme.palette.answer.correct.border,
			backgroundColor: theme.palette.answer.correct.background,
		};
	}
	if (reviewState === "incorrect") {
		return {
			borderColor: theme.palette.answer.incorrect.border,
			backgroundColor: theme.palette.answer.incorrect.background,
		};
	}
	if (selected) {
		return {
			borderColor: theme.colors.primary,
			backgroundColor: theme.colors.background,
		};
	}
	return {
		borderColor: theme.colors.outline,
		backgroundColor: theme.colors.background,
	};
};

export const useScoreToneColors = (): Record<
	ScoreTone,
	{ background: string; foreground: string; accent: string }
> => {
	const theme = useAppTheme();
	return {
		success: {
			background: theme.palette.success.info,
			foreground: theme.dark
				? theme.colors.onPrimary
				: theme.palette.success.dark,
			accent: theme.palette.success.main,
		},
		warning: {
			background: theme.colors.secondaryContainer,
			foreground: theme.colors.onSecondaryContainer,
			accent: theme.colors.secondary,
		},
		error: {
			background: theme.colors.errorContainer,
			foreground: theme.colors.onErrorContainer,
			accent: theme.colors.error,
		},
	};
};
